import React, { useCallback, useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import { Redirect, Route, Switch } from 'react-router-dom'
import { useRouteMatch } from 'react-router'
import EditorImagesTitle from './subScreens/EditorImagesTitle'
import EditorImagesProfile from './subScreens/EditorImagesProfile'
import EditorImagesMediaGallery from './subScreens/EditorImagesMediaGallery'
import { useDispatch, useSelector } from 'react-redux'
import {
  DeleteMediaFileRequest, GetMediaFileMetadataRequest,
  ListMediaFilesRequest, MediaFileMetadata,
  MediaFileSorting,
  MediaFileUsageType, SetMediaUsageRequest, UploadMediaFileRequest,
} from '@3m5/sm_publish-frontend-api'
import {
  deleteMediaFileInitiated, getMediaFileMetadataInitiated, listCoverImagesInitiated,
  listMediaFilesInitiated,
  listProfileImagesInitiated, setMediaFileUsageInitiated, setUploadedMediaFile, uploadMediaFileInitiated,
} from '../../../store/images/images.actions'
import { CoreRootState } from '../../../store/coreRoot.reducer'
import { namedRequestStatus } from '../../../store/common/common.selectors'
import { getMediaFile } from '../../../store/images/images.selector'

const EditorImages: React.FC = () => {
  const { path } = useRouteMatch()
  const dispatch = useDispatch()

  const [usageType, setUsageType] = useState<MediaFileUsageType>()

  const dispatchMediaData = useCallback((params: ListMediaFilesRequest) => dispatch(listMediaFilesInitiated(params)), [dispatch])
  const dispatchGetMediaFileData = useCallback((params: GetMediaFileMetadataRequest) => dispatch(getMediaFileMetadataInitiated(params)), [dispatch])
  const dispatchProfileImages = useCallback(() => dispatch(listProfileImagesInitiated()), [dispatch])
  const dispatchSetMediaFileUsage = useCallback((params: SetMediaUsageRequest) => dispatch(setMediaFileUsageInitiated(params)), [dispatch])
  const dispatchCoverImages = useCallback(() => dispatch(listCoverImagesInitiated()), [dispatch])
  const dispatchDeleteMediaFile = useCallback((params: DeleteMediaFileRequest) => dispatch(deleteMediaFileInitiated(params)), [dispatch])
  const dispatchUploadMediaFile = useCallback((params: UploadMediaFileRequest) => dispatch(uploadMediaFileInitiated(params)), [dispatch])
  const dispatchSetMediaFile = useCallback((params: MediaFileMetadata | undefined) => dispatch(setUploadedMediaFile(params)), [dispatch])

  const mediaFile: MediaFileMetadata | undefined = useSelector(getMediaFile)
  const statusOnUploadMediaFile: string | undefined = useSelector((state: CoreRootState) => namedRequestStatus(state, uploadMediaFileInitiated.type))

  const getTitleImages = () => {
    dispatchCoverImages()
  }

  const getProfileImages = () => {
    dispatchProfileImages()
  }

  const getMediaFiles = (queryParams: ListMediaFilesRequest) => {
    dispatchMediaData(queryParams)
  }

  const deleteFile = (id: string) => {
    dispatchDeleteMediaFile({ mediaFileId: id })
  }

  const setMediaFileUsage = (id: string, type: MediaFileUsageType) => {
    dispatchSetMediaFileUsage({
      mediaFileId: id,
      usageType: type,
    })
    dispatchSetMediaFile(undefined)
  }

  const getSelectedMediaFileData = (fileId: string) => {
    dispatchGetMediaFileData({
      mediaFileId: fileId,
    })
  }

  useEffect(() => {
    if (statusOnUploadMediaFile && statusOnUploadMediaFile === 'success' && mediaFile && usageType) {
      setMediaFileUsage(mediaFile.mediaFileId, usageType)
    }
  }, [statusOnUploadMediaFile, usageType, mediaFile])

  return (
    <Grid container columnSpacing={2} sx={{ px: 2, pb: 12 }}>
      <Grid
        xs={12}
        item
        container
        direction='row'
      >
        <Grid container item xs={12}>
          <Switch>
            <Redirect exact from={`${path}`} to={`${path}/titleImages`} />
            <Route exact path={`${path}/titleImages`}>
              <EditorImagesTitle
                getTitleImages={() => getTitleImages()}
                deleteFile={(id) => deleteFile(id)}
                uploadNewFile={(request) => {
                  dispatchUploadMediaFile(request)
                  setUsageType(MediaFileUsageType.Cover)
                }}
              />
            </Route>
            <Route path={`${path}/profileImages`}>
              <EditorImagesProfile
                getProfileImages={getProfileImages}
                deleteFile={(id) => deleteFile(id)}
                uploadNewFile={(request) => {
                  dispatchUploadMediaFile(request)
                  setUsageType(MediaFileUsageType.Profile)
                }}
              />
            </Route>
            <Route path={`${path}/mediaGallery`}>
              <EditorImagesMediaGallery
                getMediaFiles={getMediaFiles}
                deleteFile={(id) => deleteFile(id)}
                uploadNewFile={(request) => {
                  dispatchUploadMediaFile(request)
                  setUsageType(MediaFileUsageType.Posting)
                }}
                getMediaFileData={(fileId) => getSelectedMediaFileData(fileId)}
              />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EditorImages
